import deephowApiServerWrapper from "@/server/api-server";

export const postCreateOrUpdateAnnotation = (annotations) =>
  deephowApiServerWrapper("post", "/v1/annotations/batch-upsert", { annotations });

export const postFetchMultipleAnnotations = (stepIds = []) =>
  deephowApiServerWrapper("post", "/v1/annotations/get-by-steps", { stepIds });
